var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticStyle: {
      "width": "90%",
      "margin": "0 5%",
      "margin-top": "20px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "height": "30px",
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("入职类型：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.entry_type))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("招聘方式：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.recruitment_method))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("入职时间：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.induction_time))])], 1)], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "25%"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("工龄：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.working_age))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("入职薪资：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.induction_salary)), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("薪资记录")])], 1)], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("入职添加时间：\n                    ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.induction_date))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("离职添加时间：\n                    ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.quit_date))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("籍贯：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.native_place))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("员工类别：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.staff_type))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("加入集团日期：\n                    ")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.induction_time))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("所属部门：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.project_name))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("试用期：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.probation_period))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("转正日期：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.formal_date))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("所在职位：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.post_name))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("薪酬等级：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.pay_grade))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("职级：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.rank))])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("上级职位：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.we_chat))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("上级名称：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.we_chat))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("是否兼职：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.is_part_time_job_title))])], 1)], 1), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("项目经验表：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_c('el-button', {
    attrs: {
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("项目经验表")])], 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "right",
      "color": "#a1a1a1",
      "line-height": "30px"
    },
    attrs: {
      "span": 10
    }
  }, [_vm._v("现薪酬：")]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "line-height": "30px"
    },
    attrs: {
      "span": 14
    }
  }, [_vm._v(_vm._s(_vm.from.spare5))])], 1)], 1)])])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-449c8480","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/YgdaXx/tabs/work.vue
// module id = null
// module chunks = 